import PetIns from './PetIns';
export default PetIns;
